'use client';
import { Transition } from 'components';
import { LogoGreenClipArt, SaasTranslatorClipArt } from 'lib/svgs/ClipArts';
import { FC, PropsWithChildren } from 'react';
import { cn } from 'utils/cn';
import { AuthenticationProvider } from './_context/AuthenticationContext';

const LayoutAuth: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <div className="flex h-screen w-full">
    <AuthenticationProvider>
      <div className="flex w-full flex-col lg:w-1/2">
        <Transition>
          <div className="mx-auto sm:container">
            <div className="h-screen overflow-y-auto px-[7vw] pb-10 pt-32 sm:px-32">{children}</div>
          </div>
        </Transition>
      </div>
    </AuthenticationProvider>
    <div
      className={cn(
        'flex flex-col items-end justify-start overflow-hidden',
        'bg-secondary-green sm:w-2/5 md:p-0 lg:w-1/2 lg:p-10 '
      )}
    >
      <LogoGreenClipArt className="h-14 w-36 scale-[0.55] pl-4 md:scale-75 md:pl-0 lg:scale-100" />
      <div className="relative w-full">
        <SaasTranslatorClipArt className="absolute left-[-500px] top-[-650px] mt-32 scale-[0.75]" />
      </div>
    </div>
  </div>
);

export default LayoutAuth;
